// src/app/pages/users/user.service.ts
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { baseUrl } from '../../constants';

@Injectable({ providedIn: 'root' })
export class UserService {
  private baseUrl = `${baseUrl}Users`;

  constructor(private http: HttpClient) {}

  private get headers() {
    const token = localStorage.getItem('token');
    return {
      headers: new HttpHeaders({
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      })
    };
  }

  getUsers(): Observable<any[]> {
    return this.http.get<any[]>(this.baseUrl, this.headers);
  }

  getUserById(id: string): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/${id}`, this.headers);
  }

  // Observe full response as text to avoid JSON parse errors
  createUser(user: any): Observable<any> {
    return this.http.post(`${this.baseUrl}`, user, {
      ...this.headers,
      observe: 'response',
      responseType: 'text'
    } as any);
  }

  updateUser(id: string, user: any): Observable<any> {
    return this.http.put(`${this.baseUrl}/${id}`, user, {
      ...this.headers,
      observe: 'response',
      responseType: 'text'
    } as any);
  }

  deleteUser(id: string): Observable<any> {
    return this.http.delete(`${this.baseUrl}/${id}`, {
      ...this.headers,
      observe: 'response',
      responseType: 'text'
    } as any);
  }

  changeMyPassword(payload: { currentPassword: string; newPassword: string }): Observable<any> {
    return this.http.put(`${this.baseUrl}/change-password`, payload, this.headers);
  }
}
